import { useQuery } from "@tanstack/react-query";

import { api, type Schemas, unwrap } from "./client";

export type ProviderAccount = Schemas["ProviderAccountOut"];
export type ProviderOffer = Schemas["ProviderOffer"];

export const PROVIDER_ACCOUNTS_KEY = ["provider-accounts"] as const;

export function useProviderKinds() {
  return useQuery({
    queryKey: ["providers"],
    queryFn: () => unwrap(api.GET("/api/providers")),
    staleTime: Infinity,
  });
}

export function useProviderAccounts() {
  return useQuery({
    queryKey: PROVIDER_ACCOUNTS_KEY,
    queryFn: () => unwrap(api.GET("/api/provider-accounts")),
  });
}

export function useProviderBalance(accountId: string | undefined) {
  return useQuery({
    queryKey: ["provider-balance", accountId],
    queryFn: () =>
      unwrap(
        api.GET("/api/provider-accounts/{account_id}/balance", { params: { path: { account_id: accountId ?? "" } } }),
      ),
    enabled: !!accountId,
    retry: false,
  });
}

export function useProviderOffers(accountId: string | undefined) {
  return useQuery({
    queryKey: ["provider-offers", accountId],
    queryFn: () =>
      unwrap(
        api.GET("/api/provider-accounts/{account_id}/offers", { params: { path: { account_id: accountId ?? "" } } }),
      ),
    enabled: !!accountId,
    staleTime: 60_000,
    retry: false,
  });
}

export function usd(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  // Numbers often cost fractions of a cent more than a round figure: keep up to 4 places.
  return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: value < 1 ? 4 : 2 })}`;
}
